import { defineStore } from "pinia";
import { ProductXBaseStoreType } from "@xlayer/types/ProductXBaseStoreTypeInterfaces";
import { bindEvent, bindFormatter, formatSeriesNoData } from "@xlayer/composables/chartModules/chartHelper";
import germanyMapData from "@xlayer/composables/modules/germanyMap.topo.json";

export const useProductBaseStore = defineStore({
  id: "useProductXBaseStore",
  state: (): ProductXBaseStoreType => ({
    filters: {},
    germanyMap: germanyMapData,
    queryParams: {},
    productInfo: { loadingXmiddle: false } as ProductXBaseStoreType.productInfo,
    productSetup: { title: "", data: {}, class: "product", layout: {}, download: true } as ProductXBaseStoreType.productInfo,
    xMiddle: {} as ProductXBaseStoreType.xMiddle,
  }),

  actions: {
    initializeQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const queryParams: Record<string, string[]> = {};

      urlParams.forEach((value, key) => {
        if (!queryParams[key]) {
          queryParams[key] = [];
        }
        queryParams[key].push(value);
      });

      this.queryParams = queryParams;
    },
    addInitialData(data: any, layout: any, componentUrls: any, download: boolean = true): void {
      this.productSetup = { ...this.productSetup, layout, data, componentUrls, download };
      this.initializeQueryParams();
    },

    addXMiddleData(): void {
      if (this.productInfo.loadingXmiddle) return;
      this.productInfo.loadingXmiddle = true;

      this.xMiddle = this.productSetup.data;
      if (!this.xMiddle?.components) {
        console.warn("⚠️ No components found in xMiddle.");
        this.productInfo.loadingXmiddle = false;
        return;
      }

      this.xMiddle.components.forEach((component) => {
        if (["chart", "map"].includes(component.type)) {
          formatSeriesNoData(component.highchartsData);
          if (component.highchartsData.chart?.formatter) {
            bindFormatter(component.highchartsData);
          }
          if (component.events) {
            bindEvent(component);
          }
        }
      });

      if (this.xMiddle.error) {
        console.error("❌ XMiddle Error:", this.xMiddle.error);
      }

      this.productInfo.loadingXmiddle = false;
    },
  },
});
